// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1wdJl","content":"styles_content__25-13","selectAll":"styles_selectAll__3Fvha"};